import {useState} from "react";
import { Form, Input, Button, Row, Col,Typography } from "antd";
import { Recovery } from "../Recovery";

export const FormLogin = ({ handleLogin }) => {
  
  const [isModalOpen,setIsModalOpen] = useState(false);

  const onFinish = (values) => {
    handleLogin(values);
  };

  return (
    <div className="login-form">
      <Row gutter={[16,16]}>
        <Col xs={24}> 
          <p className="text">
          ¡Bienvenid@! Ingresa a tu cuenta.
          </p>
        </Col>

        <Col xs={24}>
          <Form
            name="basic"
            layout="vertical"
            onFinish={onFinish}
            autoComplete="off"
            className="fields-container"
          >
            <Form.Item
              name="username"
              rules={[
                {
                  required: true,
                  message: "Debe ingresar su email",
                  type: "email",
                },
              ]}
              className="input-container-login"
            >
              <Input placeholder="Email" className="input-login" />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[{ required: true, message: "Debe ingresar su contraseña!" }]}
              className="input-container-login"
            >
              <Input.Password placeholder="Contraseña" className="input-login"/>
            </Form.Item>
            <Form.Item className="btn-container">
              <Button className="btn-login" htmlType="submit">
                INICIAR SESIÓN
              </Button>
            </Form.Item>
          </Form>
          <Typography.Link onClick={() => setIsModalOpen(true)} style={{color:"#2f8e8d"}}>
           ¿Olvidaste tu contraseña?
          </Typography.Link>
        </Col>
      </Row>
      <Recovery isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen}/>
    </div>
  );
};
